// Toggle switch functionality for pricing page
document.addEventListener('DOMContentLoaded', function() {
  const toggleSwitch = document.getElementById('toggleSwitch');
  const monthlyLabel = document.getElementById('monthlyLabel');
  const yearlyLabel = document.getElementById('yearlyLabel');
  
  // Get price elements
  const proPriceElement = document.querySelector('.pricing-card-wrapper.featured .price');
  const teamsPriceElement = document.querySelector('.pricing-card-wrapper:nth-child(3) .price');
  
  // Function to update prices
  function updatePrices(isYearly) {
    if (isYearly) {
      proPriceElement.textContent = '$7';
      teamsPriceElement.textContent = '$5';
    } else {
      proPriceElement.textContent = '$9';
      teamsPriceElement.textContent = '$7';
    }
  }
  
  // Toggle switch click handler
  toggleSwitch.addEventListener('click', function() {
    toggleSwitch.classList.toggle('yearly');
    monthlyLabel.classList.toggle('inactive');
    yearlyLabel.classList.toggle('inactive');
    updatePrices(toggleSwitch.classList.contains('yearly'));
  });
  
  // Monthly label click handler
  monthlyLabel.addEventListener('click', function() {
    if (toggleSwitch.classList.contains('yearly')) {
      toggleSwitch.classList.remove('yearly');
      monthlyLabel.classList.remove('inactive');
      yearlyLabel.classList.add('inactive');
      updatePrices(false);
    }
  });
  
  // Yearly label click handler
  yearlyLabel.addEventListener('click', function() {
    if (!toggleSwitch.classList.contains('yearly')) {
      toggleSwitch.classList.add('yearly');
      monthlyLabel.classList.add('inactive');
      yearlyLabel.classList.remove('inactive');
      updatePrices(true);
    }
  });
});